import axios from "axios";

export const agentApi = axios.create({
  baseURL: "https://ai-agent-229275068045.us-east1.run.app",
  headers: {
    "Content-Type": "application/json",
  },
});
